// extracted by mini-css-extract-plugin
export default {"disabled":"Arrow_disabled__s0AH5","player1Enabled":"Arrow_player1Enabled__ONIMf","player2Enabled":"Arrow_player2Enabled__H8qY3"};